import { useEffect, useState } from 'react';
import {
  Plane, FileText, Shield, MapPin, Users, BookOpen, Sparkles, Hotel, Car, Briefcase,
  GraduationCap, Heart, Globe, Camera, Ship, Stethoscope, Building2, Ticket, Languages, Phone
} from 'lucide-react';
import api from './api';

export const SERVICE_ICONS = {
  Plane, FileText, Shield, MapPin, Users, BookOpen, Sparkles, Hotel, Car, Briefcase,
  GraduationCap, Heart, Globe, Camera, Ship, Stethoscope, Building2, Ticket, Languages, Phone
};

export const getServiceIcon = (name) => SERVICE_ICONS[name] || Sparkles;

export const formatServicePrice = (s) =>
  s.price != null ? `${s.price_label ? `${s.price_label} ` : ''}${s.price}$` : null;

export const useSiteServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get('/site-services')
      .then((r) => setServices(r.data))
      .catch((e) => console.error('Error fetching services:', e))
      .finally(() => setLoading(false));
  }, []);
  return { services, loading };
};
